/**
 * The EXACT server capability keys for the reception module (server/src/modules/reception/routes.js).
 * Every mutating action in the UI is gated behind one of these via useCan — the server re-checks each
 * request, so these only hide/show UI (deny-by-default).
 */
export const CAPS = {
  dossierRead: "reception.dossier.read",
  dossierCreate: "reception.dossier.create",
  dossierUpdate: "reception.dossier.update",
  ordonnanceScan: "reception.ordonnance.scan",
  demandeRead: "reception.demande.read",
  demandeCreate: "reception.demande.create",
  /** Pick a priced analysis from the shared catalogue picker (NOVA-011/032). */
  parametreSelect: "reception.parametre.select",
  /** Read the shared catalogue search surface (the picker's server gate). */
  catalogueRead: "catalogue.parametre.read",
  demandeUpdate: "reception.demande.update",
  demandeDelete: "reception.demande.delete",
  tubeGenerate: "reception.tube.generate",
  paiementCollect: "finance.paiement.collect",
  lienInvite: "reception.lien.invite",
} as const;

export type CapKey = keyof typeof CAPS;
